module.exports = __webpack_public_path__ + "img/placeholder.ca5906c7.png";